import { NextPage } from 'next'
import { LandingPage } from '@ui/components/landing/LandingPage'

export const getServerSideProps = () => {
  return {
    props: {}
  }
}

const IndexPage: NextPage = () => {
  return <LandingPage />
}

export default IndexPage
